import styled from 'styled-components'

export const QuestionListUi = styled.div`
  padding-left: 30px;
`
